import { assignSafe } from '@summit/core';
export class EPosition {
  longitude?: number;
  latitude?: number;
  altitude?: number;

  constructor(jsonData?: Partial<EPosition>) {
    //Pre clean up
    if (jsonData?.altitude && !isFinite(jsonData?.altitude)) {
      jsonData.altitude = 0;
    }
    //Normal
    assignSafe(this, jsonData);
    // console.log(`Created ${JSON.stringify(this, null, 2)} from ${JSON.stringify(jsonData, null, 2)}`)
  }

  toLatLng(): { lat: number; lng: number } {
    return {
      lat: this.latitude ?? 0,
      lng: this.longitude ?? 0
    };
  }

  toShortString(): string {
    return `${this.latitude ?? 0}, ${this.longitude ?? 0}`;
  }
}
